/**
 * @class
 * @description class being used for each single news
 * @param {NewsList} args.parent
 * @param {Node} args.element the outer element of this news
 * @param {Object} args.data the JSON data of this news
 * @param {Object} args.user the JSON user data
 * @param {Object} args.translations text translations object
 * @param {boolean} args.isTopNews
 */
export default class NewsItem {
  constructor(args) {
    this.parent = args.parent;
    this.element = args.element;
    this.data = args.data;
    this.user = args.user;
    this.translations = args.translations;
    this.isTopNews = args.isTopNews;

    this.render();
  }

  render() {
    this.element.classList.add('item');
    this.element.innerHTML = this.template;
  }

  get template() {
    return `
      <div class="item-aside" data-hightlighing-type="${this.data.highlighting_type}">
        <a href="${this.data.url}">
          <img src="http://www.mundus-agri.eu/images/news/cache/${this.data.news_image_id}_${this.isTopNews ? `landscape_large` : `square_medium`}.${this.data.image_extension}" alt="">

          ${ this.data.highlighting_type == 3 ? `
            <div class="bio-icon image-highlighting type-${this.data.highlighting_type}">
			        <i class="fa fa-leaf" area-hidden="true"></i>
			        <span>${this.translations.highlighting['type3']}</span>
			      </div>
			    ` : ''}
        </a>
      </div>
      <div class="item-main">
        <div class="item-category">${this.data.category_name}</div>
        ${this.data.highlighting_type == 1 || this.data.highlighting_type == 2 ? `

          ${(this.data.show_banderole || !this.user) && this.data.highlighting_type == 1 ? `
            <div class="item-highlighting type-${this.data.highlighting_type}">
              <span>${this.translations.highlighting['type1']}</span>
            </div>
          ` : ''}

          ${this.data.highlighting_type == 2 ?
          `<div class="item-highlighting type-${this.data.highlighting_type}">
              <span>${this.translations.highlighting['type2']}</span>
            </div>
            ` : ''}

        ` : `` }
        <div class="item-title">
          <a href="${this.data.url}">${this.data.title}</a>
        </div>
        ${this.isTopNews ? `
          <div class="item-teaser">
            ${this.data.teaser}
            <a href="${this.data.url}">${this.translations.readMore}...</a>
          </div>
        ` : ''}
        <div class="item-info">
          <span class="item-content-type">
            ${this.translations.contentType[this.data.content_type == 1 ? 'editorial' : 'corporate']}
          </span>
          <span class="item-info-devider"> - </span>
          <span class="item-date">${moment(this.data.news_date).format('L')}</span>
          <br>
          <span class="item-provider">${this.data.company_name}</span>
        </div>
      </div>
    `;
  }
}